<template>
  <v-container fluid>
    <v-row class="mb-4" align="center">
      <v-col cols="auto">
        <v-btn icon @click="$router.push('/email-blast/templates')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <h1 class="text-h5 font-weight-bold">New Email Blast Template</h1>
      </v-col>
    </v-row>

    <v-card max-width="800">
      <v-card-text>
        <template-form :submit-fn="handleSubmit" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axiosTemplate from '@/utils/axiosTemplate';
import TemplateForm from '@/components/EmailBlast/TemplateForm.vue';

export default {
  name: 'EmailBlastTemplateNew',

  components: { TemplateForm },

  methods: {
    async handleSubmit(data) {
      await axiosTemplate(process.env.VUE_APP_GATEWAY_ENDPOINT).post('v1/email-blast/templates', data);
      this.$router.push({ name: 'sendSms' });
    },
  },
};
</script>
